<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card min-width="400px">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-autocomplete
                        v-model="databaseConfig"
                        dense
                        :items="configs"
                        outlined
                        :item-text="item => item.group +' - '+ item.tag +' - '+ item.aud"
                        item-value="uid"
                        return-object
                        small-chips
                        deletable-chips
                ></v-autocomplete>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        class="ma-2"
                        color="primary"
                        :disabled="this.databaseConfig == null"
                        @click="onPressDeploy">DEPLOY
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {ConfigBackendUtils} from "@/modules/mconfigs/database/ConfigBackendUtils";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import {SharedConfigMerge} from "@/modules/mconfigs/utils/SharedConfigMerge";
import firebase from "firebase";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {SlackLogManager} from "@/common/SlackLogManager";

export default {
    name: "c-p-r-deploy-with-merge-popup",
    data: () => ({
        buttonLoading: false,
        dialog: false,
        databaseConfig: null,
        storageConfig: null
    }),
    computed: {
        configs() {
            if (this.storageConfig == null){return []}
            return ConfigBackendUtils.getConfigs().filter(e => e.group == this.storageConfig.group)
        }
    },
    methods: {
        show(storageConfig) {
            this.storageConfig = storageConfig
            this.dialog = true
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            this.dialog = false
        },
        onPressDeploy() {
            this.$confirm("Are you sure?").then(() => {
                this.buttonLoading = true
                let databaseConfig = this.databaseConfig
                let data = {
                    group:databaseConfig.group,
                    owner:firebase.auth().currentUser.uid,
                    tag:this.storageConfig.tag,
                    content: null,
                    info:this.storageConfig.info,
                    aud:databaseConfig.aud,
                    minver:databaseConfig.minver,
                    maxver:databaseConfig.maxver
                }
                let storageUid = this.storageConfig.uid
                ConfigStoreUtils.getConfigData("configs_data/" + storageUid)
                .then((storageConfigData) => {
                    const applyDeploy = (content, sharedConfigSnapshot) => {
                        data.content = content
                        ConfigBackendUtils.deployConfig(data, storageUid)
                    .then((fileName) => {
                        this.buttonLoading = false
                        this.dialog = false
                        this.$notify({title: 'Config successfully deployed!', text: "", type: "succes"});

                        ConfigStoreUtils.saveDeployedSource(
                            storageConfigData, this.storageConfig.sharedConfig || null, sharedConfigSnapshot || null, fileName[0]
                        ).catch((error) => {
                            // Log failure to persist deployed source so it is observable
                            // without affecting the primary deploy success flow.
                            console.error("Failed to save deployed config source:", error);
                        });

                        let deployData = {
                            'icon_emoji': ':hammer:',
                            'text': "<@"+PermissionsStoreUtils.getMyName()+"> deploy config to `RELEASE`",
                            'attachments': [{
                                'color': '#c340ee',
                                'fields': [
                                    {"title": "Environment", 'value': SlackLogManager.getEnv(), 'short': true},
                                    {"title": "Name", 'value': data.tag, 'short': true},
                                    {"title": "File Name", 'value': fileName[0], 'short': true},
                                    {"title": "Mode", 'value': this.storageConfig.sharedConfig ? "copy props + shared-merge" : "copy props", 'short': true},
                                    {"title": "Copy target", 'value': databaseConfig.tag, 'short': true},
                                    {"title": "Group", 'value': data.group, 'short': true},
                                    {"title": "Comment", 'value': data.info, 'short': true},
                                ]
                            }]
                        }
                        SlackLogManager.log(deployData)

                    })
                    .catch((error) => {
                        this.buttonLoading = false
                        this.dialog = false
                        this.$notify({title: 'Config deploy failed!', text: error, type: "error"});
                    })
                    }

                    if (this.storageConfig.sharedConfig) {
                        ConfigStoreUtils.getConfigData("configs_data/" + this.storageConfig.sharedConfig)
                            .then((sharedData) => {
                                const merged = SharedConfigMerge.mergeSharedIntoMap(sharedData, storageConfigData);
                                applyDeploy(merged, sharedData);
                            })
                            .catch((error) => {
                                this.buttonLoading = false
                                this.dialog = false
                                this.$notify({title: 'Failed to load shared config data!', text: error, type: "error"});
                            });
                    } else {
                        applyDeploy(storageConfigData);
                    }
                }).catch((error) => {
                    this.buttonLoading = false
                    this.dialog = false
                    this.$notify({title: 'Config deploy failed!', text: error, type: "error"});
                })
            })
        }
    }
}
</script>

<style scoped>

</style>